<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>商品信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover" style="margin-bottom: 12px; padding: 10px">
      <el-form :inline="true" :model="formInline" @submit.native.prevent>
        <el-form-item label="商品类型">
          <el-select
            v-model="formInline.goodsType"
            @change="queryClick"
            style="width: 120px"
            placeholder="商品类型"
          >
            <el-option label="全部类型" value=""></el-option>
            <el-option label="普通商品" value="default"></el-option>
            <el-option label="兽用药品" value="veterinary"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否可拆">
          <el-select
            v-model="formInline.optDetachable"
            @change="queryClick"
            style="width: 120px"
            placeholder="是否可拆"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="不可拆零" value="0"></el-option>
            <el-option label="可拆零的" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="拆零商品">
          <el-select
            v-model="formInline.optSplit"
            @change="queryClick"
            style="width: 120px"
            placeholder="拆零商品"
          >
            <el-option label="普通商品" value="0"></el-option>
            <el-option label="拆零商品" value="1"></el-option>
            <el-option label="全部" value=""></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序方式">
          <el-select
            v-model="orderByDescOrAsc"
            @change="queryClick"
            style="width: 120px"
            placeholder="排序方式"
          >
            <el-option label="降序" value="desc"></el-option>
            <el-option label="升序" value="asc"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="颜色标签">
          <el-color-picker
            v-model="formInline.optColor"
            @change="queryClick"
            :predefine="predefineColors"
          ></el-color-picker>
        </el-form-item>
        <el-form-item label="活动标签">
          <el-select
            v-model="formInline.tagLabel"
            @change="queryClick"
            style="width: 120px"
            placeholder="活动标签"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="爆款活动" value="爆款活动"> </el-option>
            <el-option label="划线活动" value="划线活动"> </el-option>
            <el-option label="滞销活动" value="滞销活动"> </el-option>
            <el-option label="临期商品" value="临期商品"> </el-option>
            <el-option label="回捞活动" value="回捞活动"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售标签">
          <el-select
            v-model="formInline.productTag2"
            @change="queryClick"
            style="width: 120px"
            placeholder="销售标签"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="一般推荐" value="一般推荐"> </el-option>
            <el-option label="重点推荐" value="重点推荐"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采购标签">
          <el-select
            v-model="formInline.productTag3"
            @change="queryClick"
            style="width: 120px"
            placeholder="采购标签"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="关注" value="关注"> </el-option>
            <el-option label="归档" value="归档"> </el-option>
            <el-option label="合并" value="合并"> </el-option>
            <el-option label="入仓" value="入仓"> </el-option>
            <el-option label="删除" value="删除"> </el-option>
            <el-option label="淘汰" value="淘汰"> </el-option>
            <el-option label="新品" value="新品"> </el-option>
            <el-option label="正常" value="正常"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类标签">
          <el-input
            v-model="formInline.classifyTagLike"
            @change="queryClick"
            style="width: 240px"
            placeholder="分类标签"
          ></el-input>
        </el-form-item>
        <el-form-item label="成分标签">
          <el-input
            v-model="formInline.productTag1Like"
            @change="queryClick"
            style="width: 240px"
            placeholder="成分标签"
          ></el-input>
        </el-form-item>
        <el-form-item label="其他标签">
          <el-input
            v-model="formInline.otherLabelLike"
            @change="queryClick"
            style="width: 240px"
            placeholder="其他标签"
          ></el-input>
        </el-form-item>
        <el-form-item label="搜索内容">
          <el-input
            v-model="formInline.queryValue"
            @change="queryClick"
            style="width: 240px"
            placeholder="关键词"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="hover">
      <vue-affix-box :offset-top="52">
        <div style="padding: 10px; background-color: #ffffff">
          <el-button icon="el-icon-s-fold" @click="switchClick"></el-button>
          <el-button type="primary" @click="createClick"> 新建商品 </el-button>
          <el-button type="default" @click="exportClick"> 导出商品 </el-button>
          <el-button type="default" @click="importClick"> 批量更新/导入 </el-button>
          <el-button type="default" @click="batchDeleteClick"> 批量删除 </el-button>
          <el-button type="default" @click="batchUpdateTagClick">
            批量修改标签
          </el-button>
          <el-button type="default" @click="batchUpdateTagLabelClick">
            批量修改活动标签
          </el-button>
          <el-button type="default" @click="batchUpdateOtherLabelClick">
            批量修改其他标签
          </el-button>
          <el-button type="default" @click="batchUpdateClassifyClick">
            批量修改分类
          </el-button>
          <el-button type="default" @click="batchUpdatePriceClick">
            批量修改价格
          </el-button>
        </div>
      </vue-affix-box>
      <div class="config-box">
        <div class="config-wrap">
          <div class="config-left" v-if="showClassify">
            <vue-affix-box
              :offset-top="120"
              style="margin-top: 10px; margin-bottom: 10px"
            >
              <height-view :offsetSize="170">
                <goods-classify-list
                  @change="handleClassifyChange"
                  :value="classifyGuid"
                />
              </height-view>
            </vue-affix-box>
          </div>
          <div :class="showClassify ? 'config-right' : 'config-right-full'">
            <x-table
              ref="list"
              listApi="biz.goods.sku.info.list"
              paginationLayout="total, sizes, prev, next, jumper"
              emptyLabel="暂无商品信息"
              actionFixed="right"
              :defaultSort="defaultSort"
              :fieldList="fieldList"
              :defaultParams="defaultParams"
              :actionList="actionList"
              :actionWidth="180"
            >
              <template slot="row-info" slot-scope="scope">
                <goods-sku-info :skuInfo="scope.row" :imageSize="80">
                  <template slot="info-append">
                    <div
                      v-if="scope.row.optColor"
                      style="color: #919191; font-size: 14px"
                    >
                      <span> 颜色标签: </span>
                      <span
                        class="goods-color-flag"
                        :style="'background-color: ' + scope.row.optColor"
                      >
                      </span>
                    </div>
                    <div
                      v-if="scope.row.otherLabel"
                      style="color: #919191; font-size: 14px; margin-top: 5px"
                    >
                      <span> 其他标签: </span>
                      <span style="color: #f56c6c">{{ scope.row.otherLabel }}</span>
                      <span v-if="!!scope.row.otherLabel">
                        ({{
                          new Date(scope.row.otherLabelTime).format(
                            "YYYY-MM-dd hh:mm:ss"
                          )
                        }})
                      </span>
                    </div>
                    <div
                      v-if="scope.row.classifyTag"
                      style="color: #919191; font-size: 14px; margin-top: 5px"
                    >
                      <span> 分类标签: </span>
                      <span style="color: #f56c6c">{{ scope.row.classifyTag }}</span>
                    </div>
                    <div
                      v-if="scope.row.productTag1"
                      style="color: #919191; font-size: 14px; margin-top: 5px"
                    >
                      <span> 成分标签: </span>
                      <span style="color: #f56c6c">{{ scope.row.productTag1 }}</span>
                    </div>
                    <div style="color: #919191; font-size: 14px; margin-top: 5px">
                      <span> 销售标签: </span>
                      <span v-if="scope.row.productTag2" style="color: #f56c6c">
                        {{ scope.row.productTag2 }}
                      </span>
                      <el-select
                        style="width: 100px"
                        placeholder="销售标签"
                        @change="handleChangeProductTag2($event, scope.row)"
                        size="mini"
                        :value="scope.row.productTag2"
                      >
                        <el-option label="不标记" value=""> </el-option>
                        <el-option label="一般推荐" value="一般推荐"> </el-option>
                        <el-option label="重点推荐" value="重点推荐"> </el-option>
                      </el-select>
                    </div>
                    <div style="color: #919191; font-size: 14px; margin-top: 5px">
                      <span> 采购标签: </span>
                      <span v-if="scope.row.productTag3" style="color: #f56c6c">
                        {{ scope.row.productTag3 }}
                      </span>
                      <el-select
                        style="width: 100px"
                        placeholder="采购标签"
                        @change="handleChangeProductTag3($event, scope.row)"
                        size="mini"
                        :value="scope.row.productTag3"
                      >
                        <el-option label="不标记" value=""> </el-option>
                        <el-option label="关注" value="关注"> </el-option>
                        <el-option label="归档" value="归档"> </el-option>
                        <el-option label="合并" value="合并"> </el-option>
                        <el-option label="入仓" value="入仓"> </el-option>
                        <el-option label="删除" value="删除"> </el-option>
                        <el-option label="淘汰" value="淘汰"> </el-option>
                        <el-option label="新品" value="新品"> </el-option>
                        <el-option label="正常" value="正常"> </el-option>
                      </el-select>
                    </div>
                    <div style="color: #919191; font-size: 14px; margin-top: 5px">
                      <span> 活动标签: </span>
                      <span v-if="scope.row.tagLabel" style="color: #f56c6c">
                        {{ scope.row.tagLabel }}
                      </span>
                      <span v-if="!!scope.row.tagLabel">
                        ({{
                          new Date(scope.row.tagLabelTime).format("YYYY-MM-dd hh:mm:ss")
                        }})
                      </span>
                      <el-select
                        style="width: 100px"
                        placeholder="自定义状态"
                        @change="handleChangeTagLabel($event, scope.row)"
                        size="mini"
                        :value="scope.row.tagLabel"
                      >
                        <el-option label="无" value=""></el-option>
                        <el-option label="爆款活动" value="爆款活动"> </el-option>
                        <el-option label="划线活动" value="划线活动"> </el-option>
                        <el-option label="滞销活动" value="滞销活动"> </el-option>
                        <el-option label="临期商品" value="临期商品"> </el-option>
                        <el-option label="回捞活动" value="回捞活动"> </el-option>
                      </el-select>
                    </div>
                    <div style="color: #919191; font-size: 14px; margin-top: 5px">
                      <span> 覆盖门店: </span>
                      <template v-if="scope.row.storeCount > 0">
                        <el-link @click="openDetailClick(scope.row)" :underline="false">
                          <span>{{ scope.row.storeCount }}门店</span>
                          <span v-if="scope.row.stockCount > 0"
                            >/共{{ scope.row.stockCount
                            }}{{ scope.row.goodsUnit || "份" }}</span
                          >
                        </el-link>
                      </template>
                      <template v-else>
                        <span>未上架</span>
                      </template>
                    </div>
                    <div style="color: #919191; font-size: 14px">
                      <span> 零售单价: </span>
                      <template v-if="scope.row.retailPrice > 0">
                        <span style="color: #f56c6c; font-size: 16px">
                          {{ scope.row.retailPrice }}
                        </span>
                        <span style="color: #333333"> 元 </span>
                      </template>
                      <template v-else>
                        <span>未设置</span>
                      </template>
                    </div>
                    <div
                      v-if="scope.row.averageCostPrice > 0"
                      style="color: #919191; font-size: 14px"
                    >
                      <span> 平均成本: </span>
                      <template> {{ +scope.row.averageCostPrice }}元/份 </template>
                    </div>
                    <!-- <div style="color: #919191; font-size: 14px">
                      <span> 消耗数量: </span>
                      <span style="margin-right: 5px">
                        7日消耗
                        <span>
                          {{ scope.row.consume7dayCount || 0 }}
                        </span>
                        份
                      </span>
                      <span style="margin-right: 5px">
                        30日消耗
                        <span>
                          {{ scope.row.consume30dayCount || 0 }}
                        </span>
                        份
                      </span>
                      <span style="margin-right: 5px">
                        150日消耗
                        <span>
                          {{ scope.row.consume150dayCount || 0 }}
                        </span>
                        份
                      </span>
                    </div>
                    <div style="color: #919191; font-size: 14px">
                      <span> 30日订单: </span>
                      <template>
                        <span> 单量：{{ +scope.row.order30dayCount }} </span>
                        <span> 金额：{{ +scope.row.order30dayAmount }} </span>
                        <span> 毛利：{{ +scope.row.order30dayProfit }} </span>
                        <span v-if="scope.row.order30dayAmount > 0">
                          毛利率：{{
                            (
                              (100 * +scope.row.order30dayProfit) /
                              +scope.row.order30dayAmount
                            ).toFixed(2)
                          }}%
                        </span>
                        <span v-else> 毛利率：- </span>
                      </template>
                    </div>
                    <div style="color: #919191; font-size: 14px">
                      <span> 7日订单: </span>
                      <template>
                        <span> 单量：{{ +scope.row.order7dayCount }} </span>
                        <span> 金额：{{ +scope.row.order7dayAmount }} </span>
                        <span> 毛利：{{ +scope.row.order7dayProfit }} </span>
                        <span v-if="scope.row.order7dayAmount > 0">
                          毛利率：{{
                            (
                              (100 * +scope.row.order7dayProfit) /
                              +scope.row.order7dayAmount
                            ).toFixed(2)
                          }}%
                        </span>
                        <span v-else> 毛利率：- </span>
                      </template>
                    </div> -->
                    <!-- <div style="color: #919191; font-size: 14px">
                      <span> 周转: </span>
                      <template v-if="scope.row.consume7dayCount > 0">
                        <span>
                          {{
                            (
                              (7 * +scope.row.stockCount) /
                              +scope.row.consume7dayCount
                            ).toFixed(2)
                          }}
                          天
                        </span>
                      </template>
                      <template v-else>
                        <span>无数据</span>
                      </template>
                    </div> -->
                    <!-- <div style="margin-top: 10px" v-if="scope.row.optSaleAbnormal == 1">
                      <span style="color: #ff0000"> 售卖异常，请处理 </span>
                    </div> -->
                  </template>
                </goods-sku-info>
              </template>
            </x-table>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<style lang="less" scoped>
.config-box {
  padding: 0px 10px;

  .config-wrap {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .config-left {
      width: 250px;
      min-height: 200px;
      margin-right: 20px;
    }

    .config-right {
      width: calc(100% - 270px);
      min-height: 200px;
    }

    .config-right-full {
      width: 100%;
    }
  }
}

.goods-color-flag {
  border-radius: 20px;
  margin-left: 5px;
  padding: 2px 10px;
  color: #ffffff;
}
</style>

<script>
import formPage from "./form.vue";
import detailPage from "./detail.vue";
import importPage from "./__index_import.vue";
import exportPage from "./__index_export.vue";
import batchDeletePage from "./__index_batch_delete.vue";
import batchUpdateTagLabelPage from "./__index_batch_update_tag_label.vue";
import batchUpdateTagPage from "./__index_batch_update_tag.vue";
import batchUpdateOtherLabelPage from "./__index_batch_update_other_label.vue";
import batchUpdateClassifyPage from "./__index_batch_update_classify.vue";
import batchUpdatePricePage from "./__index_batch_update_price.vue";
import goodsSkuInfo from "../../../../components/business/goodsSkuInfo.vue";
import goodsSkuImage from "../../../../components/business/goodsSkuImage.vue";
import goodsClassifyList from "../../../../components/business/goodsClassifyList.vue";
import HeightView from "../../../../components/heightView.vue";

export default {
  components: {
    goodsSkuInfo,
    goodsSkuImage,
    goodsClassifyList,
    HeightView,
  },
  computed: {
    defaultParams() {
      return Object.assign(
        {
          isHidden: 0,
          classifyGuid: this.classifyGuid,
        },
        this.queryModel || Object.assign({}, this.formInline)
      );
    },
    defaultSort() {
      let orderBy = "";
      if (this.orderByField) {
        orderBy = `${this.orderByField} ${this.orderByDescOrAsc}`;
      }
      return orderBy;
    },
  },
  methods: {
    refresh() {
      if (this.$refs.list) {
        this.$refs.list.refresh();
      }
    },
    clearClick() {
      this.formInline = {
        optSplit: "",
        tagLabelLike: "",
        classifyTagLike: "",
        productTag1Like: "",
        productTag2: "",
        productTag3: "",
        otherLabel: "",
        optColor: "",
        optDetachable: "",
        goodsType: "",
        queryValue: "",
      };
      this.classifyGuid = "";
      this.queryModel = null;
    },
    queryClick() {
      this.queryModel = Object.assign({}, this.formInline);
    },
    switchClick() {
      this.showClassify = !this.showClassify;
    },
    importClick() {
      this.$drawer.openDrawer(
        {
          title: "批量新增/更新商品信息",
          refresh: this.refresh,
          component: importPage,
          params: {},
        },
        true
      );
    },
    exportClick() {
      this.$drawer.openDrawer(
        {
          title: "导出商品",
          refresh: this.refresh,
          component: exportPage,
          params: {},
        },
        true
      );
    },
    batchDeleteClick() {
      this.$drawer.openDrawer(
        {
          title: "批量删除商品",
          refresh: this.refresh,
          component: batchDeletePage,
          params: {},
        },
        true
      );
    },
    batchUpdateTagClick() {
      this.$drawer.openDrawer(
        {
          title: "批量修改标签",
          refresh: this.refresh,
          component: batchUpdateTagPage,
          params: {},
        },
        true
      );
    },
    batchUpdateTagLabelClick() {
      this.$drawer.openDrawer(
        {
          title: "批量修改活动标签",
          refresh: this.refresh,
          component: batchUpdateTagLabelPage,
          params: {},
        },
        true
      );
    },
    batchUpdateOtherLabelClick() {
      this.$drawer.openDrawer(
        {
          title: "批量修改其他标签",
          refresh: this.refresh,
          component: batchUpdateOtherLabelPage,
          params: {},
        },
        true
      );
    },
    batchUpdateClassifyClick() {
      this.$drawer.openDrawer(
        {
          title: "批量修改商品分类",
          refresh: this.refresh,
          component: batchUpdateClassifyPage,
          params: {},
        },
        true
      );
    },
    batchUpdatePriceClick() {
      this.$drawer.openDrawer(
        {
          title: "批量修改商品价格",
          refresh: this.refresh,
          component: batchUpdatePricePage,
          params: {},
        },
        true
      );
    },
    createClick() {
      this.$drawer.openDrawer(
        {
          title: "新增商品信息",
          refresh: this.refresh,
          component: formPage,
          params: {
            classifyGuid: this.classifyGuid,
          },
        },
        true
      );
    },
    openDetailClick(row) {
      this.$drawer.openDrawer({
        title: "商品信息详情",
        component: detailPage,
        params: {
          guid: row.guid,
        },
      });
    },
    handleClassifyChange(guid) {
      this.classifyGuid = guid;
    },
    handleChangeProductTag2(value, row) {
      this.requestApi(
        "biz.goods.sku.info.update",
        {
          guid: row.guid,
          productTag2: value,
        },
        { showError: true }
      ).then(() => {
        this.refresh();
      });
    },
    handleChangeProductTag3(value, row) {
      this.requestApi(
        "biz.goods.sku.info.update",
        {
          guid: row.guid,
          productTag3: value,
        },
        { showError: true }
      ).then(() => {
        this.refresh();
      });
    },
    handleChangeTagLabel(value, row) {
      this.requestApi(
        "biz.goods.sku.info.update",
        {
          guid: row.guid,
          tagLabel: value,
        },
        { showError: true }
      ).then(() => {
        this.refresh();
      });
    },
  },
  data() {
    return {
      aiLoading: false,
      classifyGuid: "",
      orderByField: "",
      orderByDescOrAsc: "desc",
      showClassify: false,
      queryModel: null,
      predefineColors: ["#F65950", "#F5C208", "#40CB55", "#177DF5", "#9F4FC7", "#97979D"],
      formInline: {
        optSplit: "",
        tagLabelLike: "",
        classifyTagLike: "",
        otherLabel: "",
        optSaleAbnormal: "",
        optColor: "",
        optDetachable: "",
        goodsType: "",
        queryValue: "",
      },
      fieldList: [
        {
          label: "商品信息",
          minWidth: "360",
          slot: "info",
        },
      ],
      actionList: [
        {
          label: "详情",
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: "商品信息详情",
              refresh,
              component: detailPage,
              params: {
                guid: row.guid,
              },
            });
          },
        },
        {
          label: "编辑",
          show: (row) => {
            if (!this.$hasPower(["optSuper", "biz.goods.sku.info.update"])) {
              return false;
            }
            return true;
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer(
              {
                title: "编辑商品信息",
                refresh: this.refresh,
                component: formPage,
                params: {
                  guid: row.guid,
                },
              },
              true
            );
          },
        },
        {
          label: "复制",
          show: (row) => {
            if (!this.$hasPower(["optSuper", "biz.goods.sku.info.create"])) {
              return false;
            }
            return true;
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer(
              {
                title: "新增商品信息",
                refresh: this.refresh,
                component: formPage,
                params: {
                  copyTo: row,
                },
              },
              true
            );
          },
        },
        {
          label: "删除",
          linkType: "danger",
          show: (row) => {
            if (!this.$hasPower(["optSuper", "biz.goods.sku.info.delete"])) {
              return false;
            }
            return true;
          },
          click: (row, tag, refresh) => {
            this.$confirm(`确定删除，此操作不可恢复，请谨慎操作?`, "提示", {
              type: "warning",
            }).then(() => {
              this.requestApi(
                "biz.goods.sku.info.delete",
                {
                  guid: row.guid,
                },
                {
                  showError: true,
                }
              ).then(() => {
                this.success("保存成功");
                this.$drawer.refreshDrawer();
                refresh && refresh();
              });
            });
          },
        },
      ],
    };
  },
};
</script>
